import { animate, state, style, transition, trigger } from '@angular/animations';

export const HEADER_ANIMATION = [
  trigger('show', [
    state(
      'open',
      style({
        maxWidth: 'calc(100% - 40px)'
      })
    ),
    state(
      'close',
      style({
        maxWidth: '40px'
      })
    ),
    transition('open => closed', [animate('.4s ease-out')]),
    transition('closed => open', [animate('.4s ease-out')])
  ]),
  trigger('hide', [transition(':enter', [animate('.3s')]), transition(':leave', [animate('.1s')])])
];
